// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-stage[data-v-2e5baf34] {\n  display: block;\n  width: 100%;\n  padding: 0.5em;\n  font-size: 0.9em;\n}\n.tile.is-vertical[data-v-2e5baf34] {\n  margin-left: 1rem;\n}\n.tile.is-vertical > .tile.is-child[data-v-2e5baf34]:not(:last-child) {\n  margin-bottom: 0.5rem !important;\n}\n.tile.is-ancestor.no-margin[data-v-2e5baf34] {\n  padding-left: 0.5rem;\n}", ""]);
// Exports
module.exports = exports;
